/**
 * システム管理者一覧ページ専用i18n定数
 */

export const DISTRIBUTOR_LIST_I18N = {
  // ステータス
  status: {
    active: $localize`:@@systemAdmin.adminList.status.active:有効`,
    inactive: $localize`:@@systemAdmin.adminList.status.inactive:無効`,
  },

  // ダイアログ
  dialog: {
    confirmTitle: $localize`:@@systemAdmin.adminList.dialog.confirmTitle:ダイアログ確認`,
    confirmMessage: $localize`:@@systemAdmin.adminList.dialog.confirmMessage:ダイアログが表示されます`,
  },
} as const;

export type DistributorListI18n = typeof DISTRIBUTOR_LIST_I18N;
